/**
 * *********************************************************
 * CLIENT AIRFRAME / POWERPLANT API HELPER
 * *********************************************************
 *
 * React Component
 *   -> airframePowerplantApi.js
 *      -> server API route
 *         -> airframePowerplantRepository.js
 *            -> Firebase
 *
 * This file does NOT talk directly to Firebase.
 * *********************************************************
 */

const API_BASE = process.env.REACT_APP_API_BASE || "";

/**
 * ------------------------------------------------------------
 * UPDATE ONE AIRFRAME / POWERPLANT FIELD
 * ------------------------------------------------------------
 */
export async function updateAirframePowerplantField({
  airplaneId,
  rowKey,
  field,
  value,
}) {


    console.log("Updating airframe/powerplant:", {
        airplaneId,
        rowKey,
        field,
        value,
        url: `${API_BASE}/api/airframe-powerplant?tail=${encodeURIComponent(
                airplaneId
        )}`,
    });  
    
  const res = await fetch(
    `${API_BASE}/api/airframe-powerplant?tail=${encodeURIComponent(
      airplaneId
    )}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        rowKey,
        field,
        value,
      }),
    }
  );

  if (!res.ok) {
    throw new Error("Failed to update airframe/powerplant field");
  }

  return res.json();
}